// src/shared/components/Chips/FilterChip.jsx
import React from "react";
import { Chip, Box } from "@mui/material";
import { ChevronDown } from "lucide-react";

export const FilterChip = ({
  label,
  icon: IconComponent,
  selected = false,
  onClick,
  showDropdown = true,
}) => {
  return (
    <Chip
      icon={
        IconComponent ? (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconComponent size={16} />
          </Box>
        ) : undefined
      }
      label={
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {label}
          {showDropdown && <ChevronDown size={14} />}
        </Box>
      }
      onClick={onClick}
      variant={selected ? "filled" : "outlined"}
      color={selected ? "primary" : "default"}
      sx={{
        cursor: "pointer",
        "& .MuiChip-label": {
          px: 1,
          display: "flex",
          alignItems: "center",
        },
        "& .MuiChip-icon": {
          ml: 1,
        },
        transition: "all 0.2s",
        "&:hover": {
          bgcolor: selected ? "primary.dark" : "action.hover",
        },
      }}
    />
  );
};
